// extracted by mini-css-extract-plugin
module.exports = {"stickyWrapper":"styles_stickyWrapper__896ga","content":"styles_content__11zsF","button":"styles_button__1ZW7t"};